export default __webpack_public_path__ + "static/media/clue.f480d566.webp";